import React from 'react'
import { connect, Field, FastField } from 'formik'

import {
  Grid,
  IconButton,
  FormikInputField,
  FormikEmbedMedia,
  FormikHtmlEditor,
  FormikLayoutSelect,
  FormikDropdownSelect
} from '@paintscout/ui'

import clone from 'lodash/clone'

import SwapHorizIcon from '@material-ui/icons/SwapHoriz'
import type {
  PresentationSectionFormProps,
  FormikPresentationSectionConnectProps,
  FormikPresentationSectionValues
} from '../../'

const ThreeColumnForm = ({ formik }: PresentationSectionFormProps & FormikPresentationSectionConnectProps) => {
  const { section } = formik.values
  const { fields } = section

  const leftType = fields?.leftType ?? 'text'
  const centerType = fields?.centerType ?? 'text'
  const rightType = fields?.rightType ?? 'image'

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid container alignItems="flex-end" justifyContent="space-between" spacing={3}>
          <Grid item md={6}>
            <Field component={FormikInputField} name="section.title" label={'Title'} fullWidth={true} />
          </Grid>
          <Grid item md={6}>
            <Field
              component={FormikLayoutSelect}
              label={'Alignment'}
              name="section.fields.verticalAlign"
              vertical={true}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Field
              component={FormikDropdownSelect}
              name="section.fields.leftType"
              fullWidth={true}
              options={[
                { label: 'Image/Video', value: 'image' },
                { label: 'Text', value: 'text' }
              ]}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <IconButton onClick={handleSwapClick('left')}>
              <SwapHorizIcon />
            </IconButton>
          </Grid>
          {leftType === 'text' && (
            <Grid item xs={12}>
              <FastField
                component={FormikHtmlEditor}
                name="section.fields.leftText"
                label={'Content'}
                fullWidth={true}
                debounce={true}
                toolbar={{
                  headings: true,
                  align: true
                }}
              />
            </Grid>
          )}
          {leftType === 'image' && (
            <Grid item xs={12}>
              <Field
                component={FormikEmbedMedia}
                name="section.fields.leftImage"
                maxWidth={800}
                maxHeight={1600}
                quality={1}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={8}>
            <Field
              component={FormikDropdownSelect}
              name="section.fields.centerType"
              fullWidth={true}
              options={[
                { label: 'Image/Video', value: 'image' },
                { label: 'Text', value: 'text' }
              ]}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <IconButton onClick={handleSwapClick('center')}>
              <SwapHorizIcon />
            </IconButton>
          </Grid>
          {centerType === 'text' && (
            <Grid item xs={12}>
              <FastField
                component={FormikHtmlEditor}
                name="section.fields.centerText"
                label={'Content'}
                fullWidth={true}
                debounce={true}
                toolbar={{
                  headings: true,
                  align: true
                }}
              />
            </Grid>
          )}
          {centerType === 'image' && (
            <Grid item xs={12}>
              <Field
                component={FormikEmbedMedia}
                name="section.fields.centerImage"
                maxWidth={800}
                maxHeight={1600}
                quality={1}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid item xs={12} md={4}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Field
              component={FormikDropdownSelect}
              name="section.fields.rightType"
              fullWidth={true}
              options={[
                { label: 'Image/Video', value: 'image' },
                { label: 'Text', value: 'text' }
              ]}
            />
          </Grid>
          {rightType === 'text' && (
            <Grid item xs={12}>
              <FastField
                component={FormikHtmlEditor}
                name="section.fields.rightText"
                label={'Content'}
                debounce={true}
                fullWidth={true}
                toolbar={{
                  headings: true,
                  align: true
                }}
              />
            </Grid>
          )}
          {rightType === 'image' && (
            <Grid item xs={12}>
              <Field
                component={FormikEmbedMedia}
                name="section.fields.rightImage"
                maxWidth={800}
                maxHeight={1600}
                quality={1}
              />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  )

  function handleSwapClick(name: string) {
    return function () {
      const newSection = clone(section)

      const leftType = section.fields.leftType
      const leftImage = section.fields.leftImage
      const leftText = section.fields.leftText

      const centerType = section.fields.centerType
      const centerImage = section.fields.centerImage
      const centerText = section.fields.centerText

      if (name === 'left') {
        newSection.fields.leftType = section.fields.centerType
        newSection.fields.leftImage = section.fields.centerImage
        newSection.fields.leftText = section.fields.centerText

        newSection.fields.centerType = leftType
        newSection.fields.centerImage = leftImage
        newSection.fields.centerText = leftText
      } else if (name === 'center') {
        newSection.fields.centerType = section.fields.rightType
        newSection.fields.centerImage = section.fields.rightImage
        newSection.fields.centerText = section.fields.rightText

        newSection.fields.rightType = centerType
        newSection.fields.rightImage = centerImage
        newSection.fields.rightText = centerText
      }

      formik.setValues({ section: newSection })
    }
  }
}
export default connect<PresentationSectionFormProps, FormikPresentationSectionValues>(ThreeColumnForm)
